import { getEstimateConfirm, searchEstimateWithReject, } from "../api/generated/wrappers/estimate";
import { getEstimateConfirmDetail } from "../api/generated/wrappers/estimate";
import { getEstimateHistoryVersions } from "../api/generated/wrappers/estimate";
import { getEstimateHistoryVersionData } from "../api/generated/wrappers/estimate";
import { createQueryKeys } from "./create-query-keys";
const estimateQueryKeys = createQueryKeys("estimate", {
    confirm: (searchCardInputs) => ({
        queryKey: ["confirm"],
        queryFn: async () => await getEstimateConfirm(searchCardInputs),
    }),
    confirmWithReject: (searchCardInputs) => ({
        queryKey: ["confirmWithReject"],
        queryFn: async () => await searchEstimateWithReject(searchCardInputs),
    }),
    confirmDetail: (id) => ({
        queryKey: ["confirmDetail", id],
        queryFn: async () => await getEstimateConfirmDetail(id),
    }),
    historyVersions: (originId) => ({
        queryKey: ["historyVersions", originId],
        queryFn: async () => await getEstimateHistoryVersions(originId),
    }),
    historyVersionData: (historyId) => ({
        queryKey: ["historyVersionData", historyId],
        queryFn: async () => await getEstimateHistoryVersionData(historyId),
    }),
});
export default estimateQueryKeys;
